/**
 * Copyright © OXID eSales AG. All rights reserved.
 * See LICENSE file for license details.
 */

import ClipboardJS from 'clipboard'

import { VisualEditor } from './plugins/visualeditor.js';

import {
    getLang,
    getLoader,
    setSEOUrl,
    toggleFormButtons,
    setTabContentHeight,
    setSourceTextarea,
    setWidgetActionsAccessibility,
    setEditorActionsAccessibility,
    setSourceAction
} from './main.js';

let VE = {};
let blSourceMode = false;
let blPlainMode = false;
let fields_definition = {};
let ddh = {};

export function setWidgetMode(source, callback) {
    if (typeof source === 'function') {
        callback = source;
    }
    let blForce = false;
    if (typeof source !== 'string') {
        source = $('textarea', VE.$source).val();
    } else {
        blForce = true;
    }
    if (blPlainMode) {
        blPlainMode = false;
        setEditorActionsAccessibility(true);
    }
    if (blSourceMode || blForce) {
        getLoader().show();
        blSourceMode = false;

        setWidgetActionsAccessibility(true);
        setSourceAction(ddh.translate('DD_VISUAL_EDITOR_SHOW_SOURCE'), '<i class="fa-solid fa-code"></i>');

        VE.clear();
        VE.$grid.show();
        VE.$source.hide();
        if (source) {
            let sLang = getLang();
            let data = '&editlanguage=' + sLang + '&source=' + encodeURIComponent(source);
            $.post(VE.options.actionLink + '&fnc=getWidgets', data, function (data) {
                $.each(data, function () {
                    VE.add(this.widget, this.widget_params, this);
                });
                getLoader().hide();
                typeof callback == 'function' && callback(source, VE);
            });
        } else {
            getLoader().hide();
            typeof callback == 'function' && callback(source, VE);
        }
    } else {
        typeof callback == 'function' && callback(source, VE);
    }
}

let setSourceMode = function (callback) {
    if (blPlainMode) {
        blPlainMode = false;

        setEditorActionsAccessibility(true);
    }

    if (!blSourceMode) {
        getLoader().show();
        blSourceMode = true;
        let data = '&editlanguage=' + getLang();

        setWidgetActionsAccessibility(false);
        setSourceAction(ddh.translate('DD_VISUAL_EDITOR_SHOW_WIDGETS'), '<i class="fa-solid fa-puzzle-piece"></i>');

        $.each(VE.serialize(), function () {
            data += '&widget[' + this.row + '][' + this.col + ']=' + encodeURIComponent(JSON.stringify(this));
        });
        VE.$grid.hide();
        VE.$source.show().find('textarea').val('');
        if (data.match(/widget/)) {
            $.post(VE.options.actionLink + '&fnc=getSource', data, function (data) {
                VE.$source.show().find('textarea').val(data);
                setSourceTextarea(blSourceMode);
                getLoader().hide();
                typeof callback == 'function' && callback(data, VE);
            });
        } else {
            setSourceTextarea(blSourceMode);
            getLoader().hide();
            typeof callback == 'function' && callback('', VE);
        }
    } else {
        typeof callback == 'function' && callback($('textarea', VE.$source).val(), VE);
    }
};

// Preload Content Picker
export function preloadContentDropdown(activeValue) {
    if ($('#elm_edit_cms').length) {
        let $picker = $('#elm_edit_cms');
        $picker[0].selectize.clear();
        $picker[0].selectize.clearOptions();
        $picker[0].selectize.load(function (callback) {
            let sLang = $('#elm_lang').val();
            $.ajax({
                url: VE.options.actionLink + '&fnc=searchContents&editlanguage=' + sLang + '&all=1&definition=1',
                type: 'GET',
                error: function () {
                    toggleFormButtons(true);
                    callback();
                },
                success: function (res) {
                    if (res.fields_definition) {
                        fields_definition = res.fields_definition;
                        delete res.fields_definition;
                        res = Object.keys(res).map(function (key) {
                            return res[key];
                        });
                    }
                    callback(res);

                    $picker[0].selectize.setValue(activeValue ? activeValue : '');
                }
            });
        });
    }
}

let toggleMode = function (callback) {
    if (blSourceMode) {
        setWidgetMode(callback);
    } else {
        setSourceMode(callback);
    }
};

export function setPlainMode(callback) {
    if (!blSourceMode) {
        setSourceMode();
    }

    blPlainMode = true;

    setEditorActionsAccessibility(false);

    typeof callback == 'function' && callback($('textarea', VE.$source).val(), VE);
}

// Load Content Method
// -------------------
export function loadContent(data) {
    let sLang = getLang();
    $('input[name=selectedlanguage]').val(sLang);
    VE.clear();
    $('textarea', VE.$source).val('');
    let _setContent = function () {
        let selectizeLoadad = typeof $().selectize == 'function';
        if (data && typeof data === 'object') {
            getLoader().show();
            $.each(data, function (index, value) {
                if (index.indexOf('$') !== -1) {
                    return;
                }/*ensure fields definition includes defaults*/
                if (fields_definition[index] == null) {
                    fields_definition[index] = {id: index};
                } else {
                    if (fields_definition[index].id == null) {
                        fields_definition[index].id = index;
                    }
                }
                let fd = fields_definition[index];
                let id = "#elm_edit_" + fd.id;
                if (fd.type === 'date') {
                    value = value === '0000-00-00' ? '' : value;
                }
                let $id = $(id);
                if ($id.length >= 1) {
                    if (fd.type === 'checkbox') {
                        $id.prop('checked', value == '1');
                    } else if (fd.type === 'select' && selectizeLoadad) {
                        $id[0].selectize.setValue(value);
                    } else {
                        $id.val(value);
                    }
                } else {
                    let known_manuel_handled_fields = {
                        'desc': '',
                        'fullurl': '',
                        'type': '',
                        'fullwidth': '',
                        'newinlang': '',
                        'fromlang': '',
                        'seo': '',
                        'url': '',
                        'isactive': ''
                    };
                    if (!(index in known_manuel_handled_fields)) {
                        console.log("element " + id + " (" + index + ") not found please check template and field definition/data");
                    }
                }
            });
            if ((data.active_from && data.active_from != '0000-00-00') || (data.active_until && data.active_until != '0000-00-00')) {
                $('.dd-veditor-timespan').show();
                $('.dd-veditor-timespan-toggle').html(ddh.translate('DD_VISUAL_EDITOR_ACTIVE_TIMESPAN_HIDE'));
            }
            $('input[name="editval[oxcontents__oxtype]"][value="' + data.type + '"]').prop('checked', true);
            if (typeof data.seo == 'object') {
                $('input#elm_seo_fixed').prop('checked', (data.seo.fixed == '1'));
                $('input#elm_seo_url').val(data.seo.url);
                $('textarea#elm_seo_keywords').val(data.seo.keywords);
                $('textarea#elm_seo_description').val(data.seo.description);
            }
            if (!data.type || data.type == '0') {
                $('.dd-cms-url, .dd-cms-cat').hide();
            } else {
                if (data.type == '2') {
                    $('.dd-cms-cat').show();
                } else {
                    $('.dd-cms-cat').hide();
                }
                $('.dd-cms-url').show();
                if (data.newinlang) {
                    setSEOUrl('<code>-</code><br><br><small class="text-info">' + ddh.translate('DD_VISUAL_EDITOR_NO_LANG_INFO').replace('%s', data.fromlang) + '</small>')
                } else {
                    setSEOUrl('<a href="' + data.fullurl + '" target="_blank"><code>' + data.url + '</code></a>');
                }
            }
            $('.dd-cms-snippet').show();
            $('#elm_snippet').val(window.isSmarty ? '[{oxcontent ident="' + data.ident + '" }]' : '{% include_content "' + data.ident + '" %}');
            if (!blPlainMode) {
                $.get(VE.options.actionLink + '&fnc=getWidgets&editlanguage=' + sLang + '&id=' + data.id, function (widgets) {
                    $.each(widgets, function () {
                        VE.add(this.widget, this.widget_params, this);
                    });
                    getLoader().hide();
                    toggleFormButtons(true);
                });
            } else {
                $.get(VE.options.actionLink + '&fnc=getSource&editlanguage=' + sLang + '&id=' + data.id, function (data) {
                    VE.$source.show().find('textarea').val(data);
                    setSourceTextarea(blSourceMode);
                    getLoader().hide();
                    toggleFormButtons(true);
                });
            }
            if (!data || !data.id) {
                $('.dd-delete-action').attr('disabled', true);
            }
        } else {
            $.each(fields_definition, function (index, fd) {
                let id = fd.id ? fd.id : index;
                id = "#elm_edit_" + id;
                let default_value = fd.defaulValue == null ? fd.defaulValue : '';
                let $id = $(id);
                if (fd.type === 'checkbox') {
                    $id.prop('checked', false);
                } else if (fd.type === 'select' && selectizeLoadad) {
                    $id[0].selectize.setValue(default_value);
                } else {
                    $id.val(default_value);
                }
            });
            $('.dd-cms-snippet #elm_snippet').val('');
            setSEOUrl('<code>-</code>');
            $('.dd-cms-url').hide();
            $('.dd-veditor-timespan').hide();
            $('.dd-veditor-timespan-toggle').html(ddh.translate('DD_VISUAL_EDITOR_ACTIVE_TIMESPAN_SELECT'));
            $('input[name="editval[oxcontents__oxtype]"][value="0"]').prop('checked', true);
            $('input#elm_seo_fixed').prop('checked', false);
            $('input#elm_seo_url').val('');
            $('textarea#elm_seo_keywords').val('');
            $('textarea#elm_seo_description').val('');
            $('.dd-veditor-grid ul').css('height', 'auto');
            $('.dd-delete-action').attr('disabled', true);
        }
        setTabContentHeight();
    };
    if (data && data.plaintext == '1') {
        setPlainMode(_setContent);
    } else {
        setWidgetMode(_setContent);
    }
}

export function preload() {
    if (window.preloadid) {
        window.history.replaceState({}, document.title, location.href.replace(/\&preloadid=[a-z0-9\.\-\_]*/, ''));
    }/* Preload content picker*/
    preloadContentDropdown(window.preloadid);/* Remove main loader*/
    $('.dd-main-loader').remove();
    setTabContentHeight();
}

export function resize() {
    setSourceTextarea(blSourceMode);
    setTabContentHeight();
}

export function isSourceMode() {
    return blSourceMode;
}

export function isPlainMode() {
    return blPlainMode;
}

// Document Ready
document.addEventListener("DOMContentLoaded", () => {
    if (!window.shortcodes) {
        return;
    }
    if (typeof window.debug != 'undefined' && window.debug === true) {
        VisualEditor.DEBUG = true;
    }
    // MediaLibrary resource URLs
    if (window.mediaLibraryUrl) {
        (async () =>{
            try {
                const mediaLibraryModule = await import(window.mediaLibraryUrl);
                const { MediaLibrary } = mediaLibraryModule;
                MediaLibrary.setActionLink(window.sActionLink);
                MediaLibrary.setResourceLink(window.sMediaLink);
                ddh = mediaLibraryModule.ddh;
                window.ddh = ddh;
            } catch (error) {
                console.error("Failed to load Media Library module:", error);
            }
        })();
    } else {
        console.error("Media Library not found");
    }

    let options = window.options || {};
    options.actionLink = window.sActionLink ? window.sActionLink + '&cl=ddoevisualcmsadmin' : location.href;
    options.resourceLink = window.sMediaLink ? window.sMediaLink : null;

    // Initialize Visual Editor
    VE = new VisualEditor(window.shortcodes, window.options);

    // Add source mode element
    VE.$source = $('.dd-veditor-source', VE.$container);

    // Make Visual Editor Instance global
    window.VisualEditorInstance = VE;

    // Initialize tooltips
    $('*[data-toggle=tooltip]').tooltip();

    // Initialize CMS Picker
    if (typeof $().selectize == 'function') {
        $('.dd-cms-picker').each(function () {
            $(this).selectize({
                valueField: 'id',
                labelField: 'title',
                searchField: ['title', 'desc'],
                create: false,
                render: {
                    option: function (item, escape) {
                        return '<div class="media">' + '<div class="media-left"><i class="fa-solid fa-circle' + (item.isactive ? ' active' : '') + '"></i></div>' + '<div class="media-body">' + '<strong class="media-heading name">' + escape(item.title) + '</strong><br/>' + '<small>' + item.desc + '</small>' + '</div>' + '</div>';
                    }
                },
                load: function (query, callback) {
                    if (!query.length) {
                        return callback();
                    }
                    let sLang = getLang();
                    let blBlock = this.$input.is('#elm_tmpl_timer_cms') ? 1 : 0;
                    $.ajax({
                        url: VE.options.actionLink + '&fnc=searchContents&editlanguage=' + sLang + '&block=' + blBlock + '&search=' + encodeURIComponent(query),
                        type: 'GET',
                        error: function () {
                            callback();
                        },
                        success: function (res) {
                            callback(res);
                        }
                    });
                },
                onChange: function (value) {
                    if (this.$input.is('#elm_edit_cms') && value) {
                        loadContent.call(this, (this.options[value] ? this.options[value] : null));
                    }
                }
            });
        });

        let $objectPicker = $('.dd-article-picker, .dd-category-picker, .dd-manufacturer-picker');
        if ($objectPicker.length) {
            $objectPicker.selectize({
                valueField: 'id',
                labelField: 'title',
                searchField: ['title', 'description'],
                create: false,
                render: {
                    option: function (item, escape) {
                        return '<div class="media">' + '<div class="media-body">' + '<strong class="media-heading name">' + escape(item.title) + '</strong>' + (item.description ? '<br/><small>' + escape(item.description) + '</small>' : '') + '</div>' + '</div>';
                    }
                },
                load: function (query, callback) {
                    if (!query.length) {
                        return callback();
                    }
                    let sLang = $('#elm_lang').val();
                    let sType = $('#elm_edit_object_type').val();
                    $.ajax({
                        url: VE.options.actionLink + '&fnc=searchObjects&type=' + sType + '&editlanguage=' + sLang + '&search=' + encodeURIComponent(query),
                        type: 'GET',
                        error: function () {
                            callback();
                        },
                        success: function (res) {
                            callback(res);
                        }
                    });
                },
                onChange: function (value) {
                    if (value) {
                        let sBlock = $('#elm_edit_block').val();
                        let sType = $('#elm_edit_object_type').val();
                        let sLang = $('#elm_lang').val();
                        $.get(VE.options.actionLink + '&fnc=searchBlock&editlanguage=' + sLang + '&block=' + sBlock + '&objecttype=' + sType + '&objectid=' + value, function (data) {
                            loadContent.call(this, data);
                        });
                    } else {
                        loadContent.call(this, null);
                    }
                }
            });
        }

        $('.dd-form-picker').each(function () {
            $(this).selectize({
                render: {
                    option: function (data, escape) {
                        return '<div class="option"' + (data.color ? ' style="color: ' + data.color + '"' : '') + '>' + escape(data[this.settings.labelField]) + '</div>';
                    }
                }
            });
        });
    }

    // Set events
    $('input#elm_edit_new').change(function () {
        let $ident = $('input#elm_edit_ident');
        if ($(this).is(':checked')) {
            $('.dd-cms-search, .dd-cms-type-infos').hide();
            $ident.data('old-ident', $ident.val());
            $ident.val('');
        } else {
            $('.dd-cms-search, .dd-cms-type-infos').show();
            if ($ident.val() === '' && $ident.data('old-ident')) {
                $ident.val($ident.data('old-ident'));
            }
        }
    });

    $('select#elm_lang').change(function () {
        let $picker = $('#elm_edit_cms');
        let id = $picker.val();
        let sLang = $(this).val();/* clear cms-selectize input for template timer*/
        let $timerCmspicker = $('#elm_tmpl_timer_cms');
        if ($timerCmspicker.length && typeof $timerCmspicker[0].selectize == 'object') {
            $timerCmspicker[0].selectize.clearOptions();
        }
        if (id) {
            let self = this;
            let sLangName = $('option[value="' + sLang + '"]', this).text();
            $.ajax({
                url: VE.options.actionLink + '&fnc=searchContents&editlanguage=' + sLang + '&id=' + id,
                type: 'GET',
                success: function (res) {
                    let newinlang = (res.length && res[0].newinlang);
                    let buttons = [{
                        html: '<button type="button" class="btn btn-default" data-dismiss="modal">' + ddh.translate('DD_VISUAL_EDITOR_LANG_CHANGE_CANCEL') + '</button>',
                        action: function ($modal) {
                            $modal.modal('hide');
                            $(self).val($('input[name=selectedlanguage]').val());
                        }
                    }, {
                        html: '<button type="button" class="btn btn-warning">' + ddh.translate('DD_VISUAL_EDITOR_LANG_CHANGE_OVERWRITE') + '</button>',
                        action: function ($modal) {
                            let $editForm = $('#myedit');
                            $editForm.one('saved.ve.content', function (e) {
                                e.preventDefault();
                                location.href = VE.options.actionLink + '&editlanguage=' + sLang + '&preloadid=' + id;
                            });
                            if (!newinlang) {
                                ddh.confirm(ddh.translate('DD_VISUAL_EDITOR_LANG_CHANGE_OVERWRITE_CONFIRM').replace('%s', sLangName), function () {
                                    $modal.modal('hide');
                                    $editForm[0].fnc.value = 'save';
                                    $editForm[0].saveWidgetsOnly.value = '1';
                                    $editForm.submit();
                                });
                            } else {
                                $modal.modal('hide');
                                $editForm[0].fnc.value = 'save';
                                $editForm[0].saveWidgetsOnly.value = '1';
                                $editForm.submit();
                            }
                        }
                    }, {html: '<a href="' + VE.options.actionLink + '&editlanguage=' + sLang + '&preloadid=' + id + '" class="btn btn-primary">' + ddh.translate('DD_VISUAL_EDITOR_LANG_CHANGE_LOAD') + '</a>'}];
                    let title = ddh.translate('DD_VISUAL_EDITOR_LANG_CHANGE_TITLE');
                    let msg = ddh.translate('DD_VISUAL_EDITOR_LANG_CHANGE_MSG');
                    ddh._dialog(msg, title, buttons, 'md');
                }
            });
        } else {
            location.href = VE.options.actionLink + '&editlanguage=' + sLang;
        }
    });

    // Toogle source mode
    $('.dd-veditor-source-action').on('click', function () {
        if (!$(this).hasClass('disabled')) {
            toggleMode();
        }
    });

    // Toggle plain mode
    $('#elm_edit_plaintext').on('change', function () {
        if ($(this).prop('checked')) {
            setPlainMode();
        } else {
            setWidgetMode();
        }
    });

    // Clipboard Action
    if (typeof ClipboardJS !== 'undefined') {
        let copyAction = new ClipboardJS('.dd-clipboard-action');
        copyAction.on('success', function (e) {
            let $parent = $(e.trigger).closest('.form-group');
            $parent.addClass('has-feedback');
            window.setTimeout(function () {
                $parent.removeClass('has-feedback');
            }, 2000);
        });
    }
});
